// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom_affix":"bottom_affix-4wqqtLJ4","toTop_affix":"toTop_affix-2ggMCxFt","backToTop":"backToTop-2kPN3yfh"};